import { MTableEditField } from '@material-table/core';
import { lcsNames, M_ID } from 'utils/constants/lcsTypes';
import React from 'react';

export default (user, shipments) => {
  const columns = [
    {
      title: 'Código',
      field: 'code',
      minWidth: 200,
      initialEditValue: '',
      headerStyle: {
        textAlign: 'left',
      },
      cellStyle: {
        textAlign: 'left',
      },
      editComponent: (props) => <MTableEditField fullWidth {...props} multiline/>,
    },
    {
      title: 'LCS',
      field: 'lcs_id',
      minWidth: 100,
      initialEditValue: M_ID,
      lookup: lcsNames,
      headerStyle: {
        textAlign: 'left',
      },
      cellStyle: {
        textAlign: 'left',
      },
      editable: 'onAdd',
      render: rowData => rowData.lcs_id !== '' ? lcsNames[rowData.lcs_id] : '',
    },

    {
      title: 'Designação',
      field: 'designation',
      minWidth: 200,
      initialEditValue: '',
      headerStyle: {
        textAlign: 'left',
      },
      cellStyle: {
        textAlign: 'left',
      },
      editComponent: (props) => <MTableEditField fullWidth {...props} multiline/>,
    },
    {
      title: 'Fornecimento',
      field: 'raw_material_supplier_id',
      lookup: shipments,
      initialEditValue: Object.keys(shipments)[0],
      minWidth: 200,
      headerStyle: {
        textAlign: 'left',
      },
      cellStyle: {
        textAlign: 'left',
      },
      editable: 'onAdd',
      editComponent: (props) => <MTableEditField fullWidth {...props} multiline/>,
    },
    {
      title: 'Notas',
      field: 'notes',
      minWidth: 200,
      initialEditValue: '',
      headerStyle: {
        textAlign: 'left',
      },
      cellStyle: {
        textAlign: 'left',
      },
      editComponent: (props) => <MTableEditField fullWidth {...props} multiline/>,
    },
  ];

  const columnsAdmin = [
    {
      title: 'ID',
      field: 'id',
      editable: 'never',
      width: 100,
    },
    ...columns
  ];

  return user.superuser ? columnsAdmin : columns;
};
